/**
 * ThemeToggle (V35.5) — bouton 2-états dans la navigation.
 * Clair ↔ Sombre. Persistant via ThemeContext existant.
 */
import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export default function ThemeToggle({ className = '' }) {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isDarkMode ? 'Passer en mode clair' : 'Passer en mode sombre'}
      aria-label={isDarkMode ? 'Mode clair' : 'Mode sombre'}
      data-testid="theme-toggle"
      className={
        'relative inline-flex items-center justify-center w-9 h-9 rounded-xl ' +
        'border border-slate-200 dark:border-slate-600 ' +
        'bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm ' +
        'text-slate-700 dark:text-amber-300 ' +
        'hover:bg-slate-50 dark:hover:bg-slate-700 hover:scale-105 ' +
        'transition-all duration-300 ' +
        className
      }
    >
      <Sun className={`w-4 h-4 transition-all duration-300 ${isDarkMode ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'}`} />
      <Moon className={`absolute w-4 h-4 transition-all duration-300 ${isDarkMode ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'}`} />
    </button>
  );
}
